// Sign-in (GIOTHUB-185): the gIoTHub sign-in layout approved by Massimo for
// Floor Plan Studio on 2026-10-25 - sign-in column on the left, a dark
// blueprint of a device board on the right. The e-mail goes to Zitadel's
// sign-in page as login_hint; password, reset and MFA happen there.
import { useEffect, useRef, useState } from "preact/hooks";
import { LANGS, setLang, t, useLang } from "../i18n";
import { signIn } from "../lib/auth";
import { drawBlueprint } from "../lib/blueprint";
import "./auth.css";

export function Mark({ size = 52 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 52 52" aria-hidden="true">
      <rect x="1" y="1" width="50" height="50" rx="11" fill="var(--a-brand, #0B4F6C)" />
      <g fill="none" stroke="var(--a-brand-fg, #fff)" stroke-width="2.4" stroke-linejoin="round" stroke-linecap="round">
        <path d="M15 19.5 26 13l11 6.5v13L26 39l-11-6.5z" />
        <path d="M15 19.5 26 26l11-6.5M26 26v13" />
      </g>
      <g stroke="var(--a-brand-fg, #fff)" stroke-width="1.8" stroke-linecap="round">
        <path d="M9 23h4M9 29h4M39 23h4M39 29h4" />
      </g>
    </svg>
  );
}

export function LangSwitch() {
  const cur = useLang();
  return (
    <div class="lang" role="group" aria-label={t("common.language")}>
      {LANGS.map((l) => (
        <button key={l} type="button" aria-pressed={cur === l} onClick={() => setLang(l)}>{l.toUpperCase()}</button>
      ))}
    </div>
  );
}

export function Login({ returnTo, lead }: { returnTo?: string; lead?: string }) {
  useLang();
  const svg = useRef<SVGSVGElement>(null);
  const [email, setEmail] = useState("");
  const [bad, setBad] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (svg.current && !svg.current.childElementCount) drawBlueprint(svg.current);
  }, []);
  const go = (e: Event) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
      setBad(true);
      return;
    }
    setBusy(true);
    signIn(returnTo || location.pathname + location.search, email.trim()).catch((x) => {
      setBusy(false);
      setErr(String((x as Error).message || x));
    });
  };
  return (
    <div class="auth h-full overflow-y-auto">
      <section class="plan" aria-label={t("login.drawing")}>
        <svg ref={svg} viewBox="-90 -100 1080 670" preserveAspectRatio="xMidYMid meet" aria-hidden="true" />
        <div class="sample">{t("login.sample")}</div>
        <div class="titleblock">
          <span>{t("login.tb.type")}</span><span>ch.gimasi.lm</span>
          <span>{t("login.tb.version")}</span><span>1.8.0 · published</span>
          <span>{t("login.tb.drawing")}</span><span>main board · top</span>
          <span>{t("login.tb.scale")}</span><span>1:1 · mm</span>
        </div>
      </section>
      <aside class="side">
        <div class="box">
          <div class="brand">
            <Mark />
            <div><b>Device Type Builder</b><small>by gIoTHub</small></div>
          </div>
          <p class="lead">{lead || t("login.lead")}</p>
          <form class="stack" onSubmit={go} noValidate>
            <label class="f" for="email">{t("login.email")}
              <input id="email" type="email" autocomplete="username" placeholder="name@company.com" value={email}
                onInput={(e) => { setEmail((e.target as HTMLInputElement).value); setBad(false); }} />
            </label>
            <button class="abtn pri" type="submit" disabled={busy}>{t("login.go")}</button>
          </form>
          {bad && <p class="msg" role="alert">{t("login.bad")}</p>}
          {err && <p class="msg" role="alert">{err}</p>}
          <p class="note">{t("login.note")}</p>
        </div>
        <div class="foot">
          <span>Gimasi SA · gIoTHub · <a href="/help">{t("common.help")}</a> · <a href="/demo">{t("login.demo")}</a></span>
          <LangSwitch />
        </div>
      </aside>
    </div>
  );
}
